import { render } from "./pppoe-log-page.vue?vue&type=template&id=5f8d666e"
import script from "./pppoe-log-page.vue?vue&type=script&lang=js"
export * from "./pppoe-log-page.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__